import React from "react";

const educationContent = [
  {
    year:  ["Annual audit", "Sustainability Report Audit (ESG)",  "Transformation, merger, and acquisition (M&A) audit","Apport certification","Due diligence" ], 
    degree: "Audit Services:",
    icon:"search_mod",
    class:"no-margin-top",
    details: `Auditing is one of our core activities. Thanks to our expertise, precision, and dedication, we ensure that we conduct reliable, objective, and high-quality audits that support our clients, owners, and their business partners. Our team has experience in providing complex audit services, annual financial statement audits, transformation audits, apport certifications, and due diligence.`,
  },
  {
    year:  ["Bookkeeping services",  "Payroll","Controlling support","Compliance services" ], 
    degree: "Accounting Services",
    icon:"ballance_mod",
    class:"",
    details: `We provide a wide range of accounting and bookkeeping services to our clients. Our expert colleagues can help you navigate the complex system of accounting, payroll, tax returns, and deadlines from the start of your business activity. We can assist in special situations as well, such as transformations, mergers, or liquidations. We offer digital support for our accounting services. Through our highly secure web-based client portal, we provide our clients with continuous access to monitor the status of their company and its processes, resulting in more convenient, faster, and environmentally friendly client communication.`,
  },
  {
    year:  ["Accounting advisory",  "Management advisory","Transactional (M&A) advisory","Process optimization" ], 
    degree: "Management and Accounting Advisory",
    icon:"users_mod",
    class:"no_lg_margin",
    details: `In our rapidly changing world, accounting for certain economic events and their reporting consequences has become an increasingly complex task. Our team can help with complex and specialized issues, where the experience or expertise to address them is not necessarily available within a single organization. Whether it is supporting innovative corporate pathfinding or tackling industry-specific problems, our experts work with clients to develop solutions to manage risk, increase efficiency, and strengthen regulatory compliance.`,
  },
  {
    year:  ["Tax advisory","Transfer pricing services","Expat services","Representation in front of authorities" ], 
    degree: "Tax Advisory Services",
    icon:"funnel_dollar_mod",
    class:"no-margin-bottom",
    details: `In the field of taxation, it is essential to keep pace with the legislative environment and stay up-to-date with current provisions. Whether you are a small private company or a group of companies, you can rely on our expertise. Keeping up with the ever-changing tax system is a major challenge for companies. Thoughtful tax planning ensures that tax strategies and tax administration processes are aligned with the actual operations of the entities and the objectives of their owners. With proper tax planning, unnecessary risks can be avoided, and significant tax savings can be realized. This incremental financial capital may create new opportunities for companies.`,
  },
]
const Education = () => {
  return (
    <div class="row ">
      {educationContent.map((val, i) => (
        <div class="col-lg-6  col-sm-12">

        <ul className="d-none d-lg-block">
        <div className="service-icons-div row">
            <div className="col-lg-2 col-2 col-md-1 col-sm-1">
        <img
              src={`img/${val.icon}.svg`}
              className="services-icons"
              alt={`${val.degree}`}
            /> 
            </div>
              <div className="col-lg-10 col-md-11 col-sm-11 col-10">
              <h5 className="poppins-font text-uppercase">
            {val.degree}
            <hr className="services-line green-text margin-null"/>
          </h5>
              </div>
              </div>
        <li class= {`services-hack ${val.class}`} key={i}>
          
            
              
            
         
         
          
          <p className="open-sans-font justify padding-one-row">{val.details}</p>
         
          {val.year.map((val, i) => (
         <div class="row services-fix">   
         <div class="square col-1"> </div> <div class="col-11"><p> {val}</p></div>
         </div>
          ))}
         
        </li>
        </ul>
        <div   className={`mobile-div d-lg-none d-block ${val.class}`}>
     
          
        
            
              <div className="col-lg-12 row">
              <div className="col-2">
              <img
              src={`img/${val.icon}.svg`}
              className="services-icons"
              alt={`${val.degree}`}
            /> 
            </div>
            <div className="col-10">
              <h5 className="poppins-font text-uppercase mobile-services">
            {val.degree}
           
          </h5>
          </div>
              </div>
              <hr className="services-line green-text margin-null"/>
              
         
          
          <p className="open-sans-font justify padding-one-row">{val.details}</p>
         
          {val.year.map((val, i) => (
         <div class="row  services-fix">   
         <div class="square col-1"> </div> <div class="col-11"><p> {val}</p></div>
         </div>
         
          ))}
         
        
    </div>
    </div>
      ))}
    </div>
  );
  
};

export default Education;
